import styled from "@emotion/styled";
import { Button } from "@mui/material";
import React from "react";

const ButtonStyle = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  borderRadius: "60px",
  padding: "16px 24px",
  border: "3px solid",
  lineHeight: 1.5,
  borderColor: "#019df4",
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  ".MuiButtonBase-root:disabled": {
    cursor: "not-allowed",
    "pointer-events": "auto",
  },
});

const ButtonForm = ({
  title = "",
  disabled = false,
  onClick,
  fullWidth = true,
  onFocus,
  style
}) => {
  return (
    <ButtonStyle
      onFocus={onFocus}
      onClick={onClick}
      fullWidth={fullWidth}
      disabled={disabled}
      variant="contained"
      disableRipple
      sx = {style}
      className="metricas-boton"
    >
      {title}
    </ButtonStyle>
  );
};

export default ButtonForm;
